import {Typography, Divider, Tabs, Spin, Space, Select, Button,} from 'antd';
import {SettingOutlined } from '@ant-design/icons';
import { useContext, useEffect,useState } from 'react';
import WebLinks from '../api/WebLinks';
import TikTok from './TikTok';
import APIUtils from '../api/APIUtils';
import Cookies from 'js-cookie';
import constants from '../constants/constants';
import TikTokPromoDisplay from './TikTokPromoDisplay';
import { useHistory } from 'react-router-dom';
import { CommonContext } from '../Context';
import { trackPageAccess } from '../globalFunctions/GlobalFunctions';

const { Paragraph } = Typography;

const TikTokPromo = () => {
	//variables
	const [loader,setLoader]=useState(false);
	const [isPromoPresent,setIsPromoPresent]=useState(false);
	const TikTokItems = [
		{
			key: '1',
			label: 'Tik Toks',
			children: <><TikTok/></>,
		},
		{
			key: '2',
			label: 'Tik Tok Promo',
			children: <><TikTokPromoDisplay/></>,
		},
	];
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const history = useHistory();

	useEffect(()=>{
		trackPageAccess(buyerId,window.location.href)
		checkTikTokForBuyer();
	},[]);

	//Funtion to check if tik toks are present for buyer
	const checkTikTokForBuyer=async()=>{
		setLoader(true);
		const response = await APIUtils.apiCall('GET', WebLinks.GetTiktokPromoRecords + buyerId+"&limit=3&pageNo=1");
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			setLoader(false);
			setIsPromoPresent(response?.resultObj?.getCount>0?true:false)
		} else {
			setIsPromoPresent(false);
			setLoader(false);
		}
	};

	return (
		<div>
			<Spin spinning={loader}>
			 <div className='flex flex-wrap justify-between items-center'>
          <div className='uppercase font-bold text-xl'>TikTok Promo</div>
					<Space wrap size={20}>
						<Space wrap size='small'>
								{/* Button className='w-36' */}
								<Button type="primary" className='!capitalize' 
								onClick={() => history.push("/tiktokconfigure")} 
								icon={<SettingOutlined />}>Configure</Button>
							</Space>
							<Space wrap size='small'>
								<label>Job Status</label>
								<Select
									className='w-36'
									defaultValue={constants.ActiveJS}
								//	onChange={(e)=>{setCurrentPage(1); setJobStatus(e);getJobAD(pageSize,1,e,budget)}}
									options={[
										{
											value: constants.ActiveJS,
											label: 'Active',
										},
										{
											value: constants.InActiveJS,
											label: 'Inactive',
										},
										{
											value: constants.ErrorJS,
											label: 'Error',
										},
									]}
								/>
							</Space>
							<Space wrap size='small'>
								<label>Budget</label>
								<Select
									className='w-36'
									defaultValue='allBudget'
								//	onChange={(e)=>{setCurrentPage(1); setBudget(e);getJobAD(pageSize,1,jobStatus,e)}}
									options={[
										{
											value: 'allBudget',
											label: 'Show All',
										},
										{
											value: constants.SpendingBudget,
											label: constants.SpendingBudget,
										},
										{
											value: constants.SpentBudget,
											label: constants.SpentBudget,
										},
										{
											value: constants.NotLiveBudget,
											label: constants.NotLiveBudget,
										},
									]}
								/>
							</Space>
						</Space>
        </div>
        <Divider className='mt-3 mb-0' />
			<div>
				{!isPromoPresent?
				<TikTok/>:
				<Tabs defaultActiveKey="1" items={TikTokItems} />
			}
			</div>
			</Spin>
		</div>
	);
};

export default TikTokPromo;
